// extracted by mini-css-extract-plugin
export default {"cover":"S0F-B","hasActiveState":"rIS6X"};